<script>

import Layout from "../../layouts/main";
import appConfig from "../../../app.config";
import i18n from '../../i18n'
import OpportunityList from "@/views/business-opportunity/components/OpportunityList.vue";


export default {
  page: {
    title: i18n.global.t('menu.after-sales_service.business-opportunity'),
    meta: [{
      name: "description",
      content: appConfig.description,
    },],
  },
  data() {
    return {
      title: i18n.global.t('menu.after-sales_service.business-opportunity'),
    }
  },
  components: {
    Layout,
    OpportunityList,
  },

};
</script>

<template>
  <Layout>
    <opportunity-list :title="title" source="business"></opportunity-list>
  </Layout>

</template>
